module.exports = __webpack_public_path__ + "07525861e89c81af66e3b892f1ad2e6d.MP3";